import { COLORS } from '@btime/constants'
import React from 'react'

import FlexGrid from '../../../../components/structure/FlexGrid'
import IconText from '../../../../components/presentation/IconText'
import Link from '../../../../components/actions/Link'
import ReplyNotesInput from './ReplyNotesInput'
import ReplyPhotosInput from './ReplyPhotosInput'
import Separator from '../../../../components/helpers/Separator'

const ItemLink = ({ hide, icon, label, onClick, required }) => {
  if (hide) return false

  return (
    <Link onClick={onClick}>
      <IconText
        iconName={icon}
        left
        color={required ? COLORS.red : COLORS.dark3}
        bold
        label={label}
        separatorWeight={1}
        iconSize="1rem"
        size="small"
      />
    </Link>
  )
}

const ReplySubdataControl = React.memo(({ reply, handleChange }) => {
  const { validations } = reply
  const [notesOpen, setNotesOpen] = React.useState(!!reply.notes)
  const [photosOpen, setPhotosOpen] = React.useState(!!reply.documents && !!reply.documents.length)

  const canAddNotes = validations.notes.enabled
  const notesRequired = validations.notes.required

  const canAddPhotos = validations.photos.enabled
  const photosRequired = validations.photos.required

  if (!canAddNotes && !canAddPhotos) return false

  return (
    <>
      <Separator weight={4} />
      <FlexGrid gutter={0.5} justify="flex-start">
        <ItemLink
          hide={!canAddNotes || notesOpen}
          onClick={() => setNotesOpen(!notesOpen)}
          label="Anotações"
          icon="BsBlockquoteLeft"
          required={notesRequired}
        />

        <ItemLink
          hide={!canAddPhotos || photosOpen}
          onClick={() => setPhotosOpen(!photosOpen)}
          label="Fotos"
          icon="BsCamera"
          required={photosRequired}
        />
      </FlexGrid>

      <ReplyNotesInput open={notesOpen} value={reply.notes} handleChange={notes => handleChange({ notes })} />
      <ReplyPhotosInput
        open={photosOpen}
        value={reply.documents}
        handleChange={documents => handleChange({ documents })}
      />
    </>
  )
})

const Wrapper = ({ reply, handleChange }) => {
  return <ReplySubdataControl reply={reply} handleChange={handleChange} />
}

export default Wrapper
